import { useMemo, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { DASHBOARD_TEMPLATE } from '../templates/dashboardTemplate';

export default function DashboardPage() {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const template = useMemo(() => DASHBOARD_TEMPLATE, []);

  return (
    <>
      <Helmet>
        <title>MotoJourney | Admin Dashboard</title>
      </Helmet>
      <div className="font-display bg-background-light text-slate-900 min-h-screen">
        <div ref={containerRef} dangerouslySetInnerHTML={{ __html: template }} />
      </div>
    </>
  );
}
